import { gql } from '@apollo/client';

export const ADD_NEWS_LETTER = gql`
  mutation newsLetter_addNewsLetter(
    $projectId: Id!
    $titleColor: String!
    $readMoreLabel: String!
    $fontColor: String!
    $isLike: Boolean!
    $isView: Boolean!
    $isComment: Boolean!
    $isEngagement: Boolean!
    $isSentimenSocialMedia: Boolean!
    $isPrValue: Boolean!
    $isKeyWord: Boolean!
    $isSentiment: Boolean!
    $colorHeaderSection: String!
    $footerBackgroundColor: String!
    $templateName: String!
    $emailSubject: String!
    $recepientEmail: [String!]!
    $metric: FrequentyDelivery!
    $timezone: Int!
    $deliveryDateTime: Timestamp!
    $logoUrl: String
    $headerImageUrl: String
    $primaryText: String
    $secondaryText: String
    $footerText: String
    $instagramUrl: String
    $twitterUrl: String
    $tiktokUrl: String
    $youtubeUrl: String
  ) {
    newsLetter_addNewsLetter(
      projectId: $projectId
      titleColor: $titleColor
      readMoreLabel: $readMoreLabel
      fontColor: $fontColor
      isLike: $isLike
      isView: $isView
      isComment: $isComment
      isEngagement: $isEngagement
      isSentimenSocialMedia: $isSentimenSocialMedia
      isPrValue: $isPrValue
      isKeyWord: $isKeyWord
      isSentiment: $isSentiment
      colorHeaderSection: $colorHeaderSection
      footerBackgroundColor: $footerBackgroundColor
      templateName: $templateName
      emailSubject: $emailSubject
      recepientEmail: $recepientEmail
      metric: $metric
      timezone: $timezone
      deliveryDateTime: $deliveryDateTime
      logoUrl: $logoUrl
      headerImageUrl: $headerImageUrl
      primaryText: $primaryText
      secondaryText: $secondaryText
      footerText: $footerText
      instagramUrl: $instagramUrl
      twitterUrl: $twitterUrl
      tiktokUrl: $tiktokUrl
      youtubeUrl: $youtubeUrl
    )
  }
`;

export const EDIT_NEWSLETTER = gql`
  mutation newsLetter_editNewsLetter(
    $projectId: Id!
    $titleColor: String!
    $readMoreLabel: String!
    $fontColor: String!
    $isLike: Boolean!
    $isView: Boolean!
    $isComment: Boolean!
    $isEngagement: Boolean!
    $isSentimenSocialMedia: Boolean!
    $isPrValue: Boolean!
    $isKeyWord: Boolean!
    $isSentiment: Boolean!
    $colorHeaderSection: String!
    $footerBackgroundColor: String!
    $templateName: String!
    $emailSubject: String!
    $recepientEmail: [String!]!
    $metric: FrequentyDelivery!
    $timezone: Int!
    $deliveryDateTime: Timestamp!
    $newsLetterId: Id!
    $logoUrl: String
    $headerImageUrl: String
    $primaryText: String
    $secondaryText: String
    $footerText: String
    $instagramUrl: String
    $twitterUrl: String
    $tiktokUrl: String
    $youtubeUrl: String
  ) {
    newsLetter_editNewsLetter(
      projectId: $projectId
      titleColor: $titleColor
      readMoreLabel: $readMoreLabel
      fontColor: $fontColor
      isLike: $isLike
      isView: $isView
      isComment: $isComment
      isEngagement: $isEngagement
      isSentimenSocialMedia: $isSentimenSocialMedia
      isPrValue: $isPrValue
      isKeyWord: $isKeyWord
      isSentiment: $isSentiment
      colorHeaderSection: $colorHeaderSection
      footerBackgroundColor: $footerBackgroundColor
      templateName: $templateName
      emailSubject: $emailSubject
      recepientEmail: $recepientEmail
      metric: $metric
      timezone: $timezone
      deliveryDateTime: $deliveryDateTime
      newsLetterId: $newsLetterId
      logoUrl: $logoUrl
      headerImageUrl: $headerImageUrl
      primaryText: $primaryText
      secondaryText: $secondaryText
      footerText: $footerText
      instagramUrl: $instagramUrl
      twitterUrl: $twitterUrl
      tiktokUrl: $tiktokUrl
      youtubeUrl: $youtubeUrl
    )
  }
`;

export const EDIT_NEWSLETTER_DETAIL = gql`
  mutation newsLetter_editNewsLetterDetail(
    $newsLetterDetailArgument: [NewsLetterDetailArgument!]!
    $projectId: Id!
    $newsLetterId: Id!
  ) {
    newsLetter_editNewsLetterDetail(
      newsLetterDetailArgument: $newsLetterDetailArgument
      projectId: $projectId
      newsLetterId: $newsLetterId
    )
  }
`;

// muation scheduler news letter
export const ADD_NEWS_LETTER_AUTOMATIC = gql`
  mutation newsLetter_addNewsLetterAutomatic(
    $projectId: Id!
    $titleColor: String!
    $readMoreLabel: String!
    $fontColor: String!
    $isLike: Boolean!
    $isView: Boolean!
    $isComment: Boolean!
    $isEngagement: Boolean!
    $isSentimenSocialMedia: Boolean!
    $isPrValue: Boolean!
    $isKeyWord: Boolean!
    $isSentiment: Boolean!
    $colorHeaderSection: String!
    $footerBackgroundColor: String!
    $templateName: String!
    $emailSubject: String!
    $recepientEmail: [String!]!
    $metric: FrequentyDelivery!
    $timezone: Int!
    $deliveryDateTime: Timestamp!
    $logoUrl: String
    $headerImageUrl: String
    $primaryText: String
    $secondaryText: String
    $footerText: String
    $instagramUrl: String
    $twitterUrl: String
    $tiktokUrl: String
    $youtubeUrl: String
    $newsLetterStart: [String!]!
  ) {
    newsLetter_addNewsLetterAutomatic(
      projectId: $projectId
      titleColor: $titleColor
      readMoreLabel: $readMoreLabel
      fontColor: $fontColor
      isLike: $isLike
      isView: $isView
      isComment: $isComment
      isEngagement: $isEngagement
      isSentimenSocialMedia: $isSentimenSocialMedia
      isPrValue: $isPrValue
      isKeyWord: $isKeyWord
      isSentiment: $isSentiment
      colorHeaderSection: $colorHeaderSection
      footerBackgroundColor: $footerBackgroundColor
      templateName: $templateName
      emailSubject: $emailSubject
      recepientEmail: $recepientEmail
      metric: $metric
      timezone: $timezone
      deliveryDateTime: $deliveryDateTime
      logoUrl: $logoUrl
      headerImageUrl: $headerImageUrl
      primaryText: $primaryText
      secondaryText: $secondaryText
      footerText: $footerText
      instagramUrl: $instagramUrl
      twitterUrl: $twitterUrl
      tiktokUrl: $tiktokUrl
      youtubeUrl: $youtubeUrl
      newsLetterStart: $newsLetterStart
    )
  }
`;

export const EDIT_NEWSLETTER_AUTOMATIC = gql`
  mutation newsLetter_editNewsLetterAutomatic(
    $projectId: Id!
    $titleColor: String!
    $readMoreLabel: String!
    $fontColor: String!
    $isLike: Boolean!
    $isView: Boolean!
    $isComment: Boolean!
    $isEngagement: Boolean!
    $isSentimenSocialMedia: Boolean!
    $isPrValue: Boolean!
    $isKeyWord: Boolean!
    $isSentiment: Boolean!
    $colorHeaderSection: String!
    $footerBackgroundColor: String!
    $templateName: String!
    $emailSubject: String!
    $recepientEmail: [String!]!
    $metric: FrequentyDelivery!
    $timezone: Int!
    $deliveryDateTime: Timestamp!
    $newsLetterAutomaticId: Id!
    $logoUrl: String
    $headerImageUrl: String
    $primaryText: String
    $secondaryText: String
    $footerText: String
    $instagramUrl: String
    $twitterUrl: String
    $tiktokUrl: String
    $youtubeUrl: String
    $newsLetterStart: [String!]!
  ) {
    newsLetter_editNewsLetterAutomatic(
      projectId: $projectId
      titleColor: $titleColor
      readMoreLabel: $readMoreLabel
      fontColor: $fontColor
      isLike: $isLike
      isView: $isView
      isComment: $isComment
      isEngagement: $isEngagement
      isSentimenSocialMedia: $isSentimenSocialMedia
      isPrValue: $isPrValue
      isKeyWord: $isKeyWord
      isSentiment: $isSentiment
      colorHeaderSection: $colorHeaderSection
      footerBackgroundColor: $footerBackgroundColor
      templateName: $templateName
      emailSubject: $emailSubject
      recepientEmail: $recepientEmail
      metric: $metric
      timezone: $timezone
      deliveryDateTime: $deliveryDateTime
      newsLetterAutomaticId: $newsLetterAutomaticId
      logoUrl: $logoUrl
      headerImageUrl: $headerImageUrl
      primaryText: $primaryText
      secondaryText: $secondaryText
      footerText: $footerText
      instagramUrl: $instagramUrl
      twitterUrl: $twitterUrl
      tiktokUrl: $tiktokUrl
      youtubeUrl: $youtubeUrl
      newsLetterStart: $newsLetterStart
    )
  }
`;

export const CREATE_DATA_SOURCE_SOSMED = gql`
  mutation newsLetter_createDataSourceSocmed(
    $projectId: Id!
    $newsLetterAutomaticId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $objectList: [Id!]!
    $labelList: [Id!]
    $excludeLabelList: [Id!]
    $granularity: GranularityInput!
    $timezone: Int!
    $sentiment: [Sentiment!]
    $postOwnership: [PostOwnership!]
    $validationList: [StreamValidation!]
    $includeKeywords: [String!]
    $excludeKeywords: [String!]
    $fromUsername: String!
    $contentTypeList: [ContentType!]
    $sentimentConfidenceLevelMin: BigDecimal!
    $sentimentConfidenceLevelMax: BigDecimal!
    $replyToOriginalId: [String!]
    $showEmptyLabel: Boolean
    $queryStringBooleanOperator: QueryStringBooleanOperator
    $languageList: [String!]
    $userRating: [Int!]
    $validationEmotionList: [StreamValidation!]
    $emotion: [Emotion!]
    $retweetFilter: RetweetFilter
    $talkType: [TalkType!]
    $ageGeneration: [AgeGeneration!]
  ) {
    newsLetter_createDataSourceSocmed(
      projectId: $projectId
      newsLetterAutomaticId: $newsLetterAutomaticId
      start: $start
      end: $end
      objectList: $objectList
      labelList: $labelList
      excludeLabelList: $excludeLabelList
      granularity: $granularity
      timezone: $timezone
      sentiment: $sentiment
      postOwnership: $postOwnership
      validationList: $validationList
      includeKeywords: $includeKeywords
      excludeKeywords: $excludeKeywords
      fromUsername: $fromUsername
      contentTypeList: $contentTypeList
      sentimentConfidenceLevelMin: $sentimentConfidenceLevelMin
      sentimentConfidenceLevelMax: $sentimentConfidenceLevelMax
      replyToOriginalId: $replyToOriginalId
      showEmptyLabel: $showEmptyLabel
      queryStringBooleanOperator: $queryStringBooleanOperator
      languageList: $languageList
      userRating: $userRating
      emotion: $emotion
      validationEmotionList: $validationEmotionList
      retweetFilter: $retweetFilter
      talkType: $talkType
      ageGeneration: $ageGeneration
    )
  }
`;

export const CREATE_DATA_SOURCE_ONM = gql`
  mutation newsLetter_createDataSourceOnlineNews(
    $projectId: Id!
    $newsLetterAutomaticId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $mediaList: [String!]!
    $granularity: GranularityInput!
    $excludeMediaList: [String!]
    $timezone: Int!
    $phrases: [String!]
    $sentiment: [Sentiment!]
    $labelList: [Id!]
    $clippingId: Id
    $includeKeywords: [String!]
    $excludeKeywords: [String!]
    $searchType: SearchType
    $languageList: [String!]
    $validationList: [ValidationType!]
    $queryStringBooleanOperator: QueryStringBooleanOperator
    $tier: [Int!]
    $excludeLabelList: [Id!]
    $showEmptyLabel: Boolean
  ) {
    newsLetter_createDataSourceOnlineNews(
      projectId: $projectId
      newsLetterAutomaticId: $newsLetterAutomaticId
      start: $start
      end: $end
      mediaList: $mediaList
      granularity: $granularity
      excludeMediaList: $excludeMediaList
      timezone: $timezone
      phrases: $phrases
      sentiment: $sentiment
      labelList: $labelList
      clippingId: $clippingId
      includeKeywords: $includeKeywords
      excludeKeywords: $excludeKeywords
      searchType: $searchType
      languageList: $languageList
      validationList: $validationList
      queryStringBooleanOperator: $queryStringBooleanOperator
      tier: $tier
      excludeLabelList: $excludeLabelList
      showEmptyLabel: $showEmptyLabel
    )
  }
`;

export const CREATE_DATA_SOURCE_BROADCAST = gql`
  mutation newsLetter_createDataSourceBroadcast(
    $projectId: Id!
    $newsLetterAutomaticId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $mediaList: [String!]!
    $granularity: GranularityInput!
    $timezone: Int!
    $sentiment: [Sentiment!]
    $labelList: [Id!]
    $clippingId: Id
    $includeKeywords: [String!]
    $excludeKeywords: [String!]
    $phrases: [String!]
    $languageList: [String!]
    $searchType: SearchType
    $validationList: [ValidationType!]
  ) {
    newsLetter_createDataSourceBroadcast(
      projectId: $projectId
      newsLetterAutomaticId: $newsLetterAutomaticId
      start: $start
      end: $end
      mediaList: $mediaList
      granularity: $granularity
      timezone: $timezone
      sentiment: $sentiment
      labelList: $labelList
      clippingId: $clippingId
      includeKeywords: $includeKeywords
      excludeKeywords: $excludeKeywords
      phrases: $phrases
      languageList: $languageList
      searchType: $searchType
      validationList: $validationList
    )
  }
`;

export const CREATE_DATA_SOURCE_PRINT_MEDIA = gql`
  mutation newsLetter_createDataSourcePrint(
    $projectId: Id!
    $newsLetterAutomaticId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $mediaList: [String!]!
    $granularity: GranularityInput!
    $timezone: Int!
    $sentiment: [Sentiment!]
    $labelList: [Id!]
    $clippingId: Id
    $includeKeywords: [String!]
    $excludeKeywords: [String!]
    $phrases: [String!]
    $languageList: [String!]
    $searchType: SearchType
    $validationList: [ValidationType!]
  ) {
    newsLetter_createDataSourcePrint(
      projectId: $projectId
      newsLetterAutomaticId: $newsLetterAutomaticId
      start: $start
      end: $end
      mediaList: $mediaList
      granularity: $granularity
      timezone: $timezone
      sentiment: $sentiment
      labelList: $labelList
      clippingId: $clippingId
      includeKeywords: $includeKeywords
      excludeKeywords: $excludeKeywords
      phrases: $phrases
      languageList: $languageList
      searchType: $searchType
      validationList: $validationList
    )
  }
`;
